import useAxios from '../../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const getIncomePlans = createAsyncThunk('incomeplans/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/incomeplans/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    // return custom error message from API if any
    if (error.response && error.response.data.detail) {
      return rejectWithValue(error.response.data.detail)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

export const saveIncomePlan = createAsyncThunk(
  'incomeplan/save',
  async (incomeplan, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.put(`/api/incomeplans/${incomeplan.id}/`, incomeplan)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const createIncomePlan = createAsyncThunk(
  'incomeplan/create',
  async (incomeplan, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.post('/api/incomeplans/', incomeplan)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const deleteIncomePlan = createAsyncThunk(
  'incomeplan/delete',
  async (incomeplan, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.delete(`/api/incomeplans/${incomeplan.id}/`)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)
